"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logger_browser_1 = require("./logger.browser");
exports.default = logger_browser_1.default;
exports.log = logger_browser_1.log;
exports.error = logger_browser_1.error;
exports.warn = logger_browser_1.warn;
exports.info = logger_browser_1.info;
exports.debug = logger_browser_1.debug;
exports.verbose = logger_browser_1.verbose;
exports.silly = logger_browser_1.silly;
//# sourceMappingURL=index.browser.js.map